import { styled } from '@mui/system'
import { Typography } from '@mui/material'

export const StatisticsViewPageMain = styled('main')(() => ({
  boxSizing: 'border-box',
  minHeight: '100vh',
  padding: '1.6rem',
  background: 'rgba(0,0,0,0.05)',
}))

export const StatisticsViewPageTitle = styled(Typography)(() => ({
  zIndex: '0',
  position: 'relative',
  top: '-3rem',
  alignItems: 'center',
  flexDirection: 'column',
  display: 'flex',
  width: 'auto',
  textAlign: 'center',
}))

export const StatisticsViewPageFormControl = styled('div')(({ theme }) => ({
  marginTop: '0.6rem',
  width: 'fit-content',
  display: 'none',
  align: 'center',
  [theme.breakpoints.down('lg')]: {
    display: 'block',
  },
}))

export const StatisticsViewSection = styled('section')(({ theme }) => ({
  justifyContent: 'center',
  gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
  gridGap: '1.6rem',
  display: 'grid',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(var(--columnCount), 1fr)',
  },
}))
